// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.backgroundTab {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  border-radius: 30px;
  background-color: #ffffff;
  transition: transform 0.3s ease;
  z-index: -1;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 6px;
}

.tab {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 5rem;
  border-radius: 30px;
  color: #333; /* Couleur du texte par défaut (bleu) */
  transition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */
}

.selected {
  color: #007bff;
  transition: color 0.3s ease;
}

.position {
  transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */
}

ion-header ion-toolbar {
  --background: transparent;
}
ion-header ion-toolbar ion-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.subscription-container {
  padding: 16px;
}

.section-title {
  margin: 24px 0 16px;
}
.section-title h2 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.section-title .title-underline {
  width: 40px;
  height: 3px;
  background: var(--ion-color-primary);
  margin-top: 8px;
  border-radius: 2px;
}

.current-plan {
  margin-bottom: 32px;
}
.current-plan .active-plan-card {
  background: #ffffff;
  border-radius: 20px;
  margin: 0;
  border: 2px solid var(--ion-color-primary);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  overflow: visible;
  position: relative;
}
.current-plan .plan-content {
  padding: 24px;
}
.current-plan .plan-badge {
  position: absolute;
  top: 10px;
  right: 24px;
  background: var(--ion-color-primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.current-plan .plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.current-plan .plan-header h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--ion-color-primary);
  margin: 0;
}
.current-plan .delete-button {
  --color: var(--ion-color-danger);
  --padding-start: 8px;
  --padding-end: 8px;
}
.current-plan .plan-details {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: #666;
}
.current-plan .plan-details ion-icon {
  color: var(--ion-color-success);
  font-size: 1.2rem;
}
.current-plan .plan-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 16px;
}
.current-plan .plan-price .amount {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
}
.current-plan .plan-price .period {
  font-size: 1rem;
  color: #666;
}
.current-plan .plan-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 0.9rem;
}
.current-plan .plan-status ion-icon {
  font-size: 1.1rem;
  color: var(--ion-color-primary);
}

.active-plan-card {
  background: linear-gradient(135deg, var(--ion-color-primary), var(--ion-color-primary-shade));
  color: white;
  border-radius: 16px;
  margin: 0;
  box-shadow: 0 8px 16px rgba(var(--ion-color-primary-rgb), 0.2);
}

.plan-card {
  background: #ffffff;
  border-radius: 16px;
  margin: 0 0 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}
.plan-card:active {
  transform: scale(0.98);
}

.plan-content {
  padding: 20px;
}
.plan-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 16px;
}

.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delete-button {
  --padding-start: 8px;
  --padding-end: 8px;
  --color: rgba(255, 255, 255, 0.9);
}

.plan-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.plan-price .amount {
  font-size: 1.8rem;
  font-weight: 700;
}
.plan-price .period {
  font-size: 0.9rem;
  opacity: 0.8;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.select-button {
  margin-top: 20px;
  --border-radius: 12px;
  font-weight: 600;
}

.back-button {
  --padding-start: 0;
  --padding-end: 0;
  margin-left: 8px;
}
.back-button ion-icon {
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/account/subscribe/subscribe.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,WAAA;EACA,gDAAA;AAEJ;;AACA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA,EAAA,uCAAA;EACA,2BAAA,EAAA,oDAAA;AAEA;;AACA;EACA,cAAA;EACA,2BAAA;AAEA;;AAEA;EACI,2BAAA,EAAA,6DAAA;AACJ;;AAGE;EACE,yBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;AAAN;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;AAIE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAFJ;AAKE;EACE,WAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,mBAAA;AAJF;AAME;EACE,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,0CAAA;EACA,0CAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,aAAA;AALJ;AAQE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AANJ;AASE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AASI;EACE,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAPN;AAWE;EACE,gCAAA;EACA,oBAAA;EACA,kBAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;AAVJ;AAYI;EACE,+BAAA;EACA,iBAAA;AAVN;AAcE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AAZJ;AAcI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAZN;AAeI;EACE,eAAA;EACA,WAAA;AAbN;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,+BAAA;AAfN;;AAoBA;EACE,6FAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,8DAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,2CAAA;AAjBF;AAmBE;EACE,sBAAA;AAjBJ;;AAqBA;EACE,aAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,kBAAA;EACA,iCAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAnBF;AAqBE;EACE,iBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,iBAAA;EACA,YAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AArBF;AAuBE;EACE,eAAA;AArBJ","sourcesContent":[".backgroundTab {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 50%; \r\n    height: 100%;\r\n    border-radius: 30px;\r\n    background-color: #ffffff; \r\n    transition: transform 0.3s ease; \r\n    z-index: -1; \r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 6px;\r\n}\r\n\r\n.tab {\r\nflex: 1;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\ncursor: pointer;\r\nwidth: 5rem;\r\nborder-radius: 30px;\r\ncolor: #333; /* Couleur du texte par défaut (bleu) */\r\ntransition: color 0.3s ease; /* Ajoutez une transition pour la couleur du texte */\r\n}\r\n\r\n.selected {\r\ncolor: #007bff;\r\ntransition: color 0.3s ease;\r\n}\r\n\r\n\r\n.position {\r\n    transform: translateX(100%); /* Déplacez la backgroundTab à droite de 100% de sa largeur */\r\n}\r\n\r\nion-header {\r\n  ion-toolbar {\r\n    --background: transparent;\r\n    \r\n    ion-title {\r\n      font-size: 1.5rem;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n}\r\n\r\n.subscription-container {\r\n  padding: 16px;\r\n}\r\n\r\n.section-title {\r\n  margin: 24px 0 16px;\r\n  \r\n  h2 {\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0;\r\n  }\r\n  \r\n  .title-underline {\r\n    width: 40px;\r\n    height: 3px;\r\n    background: var(--ion-color-primary);\r\n    margin-top: 8px;\r\n    border-radius: 2px;\r\n  }\r\n}\r\n\r\n.current-plan {\r\n  margin-bottom: 32px;\r\n  \r\n  .active-plan-card {\r\n    background: #ffffff;\r\n    border-radius: 20px;\r\n    margin: 0;\r\n    border: 2px solid var(--ion-color-primary);\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\r\n    overflow: visible;\r\n    position: relative;\r\n  }\r\n\r\n  .plan-content {\r\n    padding: 24px;\r\n  }\r\n\r\n  .plan-badge {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 24px;\r\n    background: var(--ion-color-primary);\r\n    color: white;\r\n    padding: 4px 12px;\r\n    border-radius: 12px;\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.5px;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  .plan-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n\r\n    h3 {\r\n      font-size: 1.4rem;\r\n      font-weight: 700;\r\n      color: var(--ion-color-primary);\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  .delete-button {\r\n    --color: var(--ion-color-danger);\r\n    --padding-start: 8px;\r\n    --padding-end: 8px;\r\n  }\r\n\r\n  .plan-details {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: 16px;\r\n    color: #666;\r\n\r\n    ion-icon {\r\n      color: var(--ion-color-success);\r\n      font-size: 1.2rem;\r\n    }\r\n  }\r\n\r\n  .plan-price {\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 8px;\r\n    margin-bottom: 16px;\r\n\r\n    .amount {\r\n      font-size: 2rem;\r\n      font-weight: 700;\r\n      color: #333;\r\n    }\r\n\r\n    .period {\r\n      font-size: 1rem;\r\n      color: #666;\r\n    }\r\n  }\r\n\r\n  .plan-status {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    color: #666;\r\n    font-size: 0.9rem;\r\n\r\n    ion-icon {\r\n      font-size: 1.1rem;\r\n      color: var(--ion-color-primary);\r\n    }\r\n  }\r\n}\r\n\r\n.active-plan-card {\r\n  background: linear-gradient(135deg, var(--ion-color-primary), var(--ion-color-primary-shade));\r\n  color: white;\r\n  border-radius: 16px;\r\n  margin: 0;\r\n  box-shadow: 0 8px 16px rgba(var(--ion-color-primary-rgb), 0.2);\r\n}\r\n\r\n.plan-card {\r\n  background: #ffffff;\r\n  border-radius: 16px;\r\n  margin: 0 0 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n\r\n  &:active {\r\n    transform: scale(0.98);\r\n  }\r\n}\r\n\r\n.plan-content {\r\n  padding: 20px;\r\n\r\n  h3 {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    margin: 0 0 16px;\r\n  }\r\n}\r\n\r\n.plan-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.delete-button {\r\n  --padding-start: 8px;\r\n  --padding-end: 8px;\r\n  --color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.plan-price {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n\r\n  .amount {\r\n    font-size: 1.8rem;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .period {\r\n    font-size: 0.9rem;\r\n    opacity: 0.8;\r\n  }\r\n}\r\n\r\n.plans-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.select-button {\r\n  margin-top: 20px;\r\n  --border-radius: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.back-button {\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  margin-left: 8px;\r\n  \r\n  ion-icon {\r\n    font-size: 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
